import _ from 'lodash';
import template from './pozicije.html';



class PozicijeController {
    constructor() {
        // this.items = [];
    }

    $onInit() {

    }

    pozicijaClicked(pozicija){
        this.onClick({pozicija: pozicija});
    }

}

PozicijeController.$inject = [];

const PozicijeComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: PozicijeController,
    controllerAs: 'vm',
    bindings: {
        items: '<',
        onClick: '&',
    }
};

export {PozicijeComponent};
export {PozicijeController};



// WEBPACK FOOTER //
// ./app/components/stavkaNaloga/pozicije.component.js